import { useEffect, useRef, useState } from "react";

const PING_URL = `${process.env.REACT_APP_BACKEND_URL}/api/`;
const SLOW_MS = 2500;
const INTERVAL = 15000;

// Devuelve el estado de conexión: "online" | "slow" | "offline".
export function useConnection() {
  const [status, setStatus] = useState(navigator.onLine ? "online" : "offline");
  const timer = useRef();

  useEffect(() => {
    let active = true;

    const check = async () => {
      if (!navigator.onLine) { if (active) setStatus("offline"); return; }
      const conn = navigator.connection;
      if (conn && (conn.effectiveType === "slow-2g" || conn.effectiveType === "2g")) {
        if (active) setStatus("slow");
        return;
      }
      const ctrl = new AbortController();
      const to = setTimeout(() => ctrl.abort(), SLOW_MS);
      const t0 = performance.now();
      try {
        await fetch(PING_URL, { signal: ctrl.signal, credentials: "include", cache: "no-store" });
        clearTimeout(to);
        const dt = performance.now() - t0;
        if (active) setStatus(dt > SLOW_MS ? "slow" : "online");
      } catch {
        clearTimeout(to);
        if (active) setStatus(navigator.onLine ? "slow" : "offline");
      }
    };

    const onOnline = () => { setStatus("online"); check(); };
    const onOffline = () => setStatus("offline");
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    const conn = navigator.connection;
    if (conn) conn.addEventListener("change", check);

    check();
    timer.current = setInterval(check, INTERVAL);
    return () => {
      active = false;
      clearInterval(timer.current);
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
      if (conn) conn.removeEventListener("change", check);
    };
  }, []);

  return status;
}
